
import React, {FC, RefObject, useRef} from 'react';
import {RgbaColor, RgbaColorPicker} from 'react-colorful';
import {SetColor} from 'templates/reports/Section/ScanImages/useColors';

import {useOutsider} from './outsider';

import * as styles from './styles.module.scss';

type PickerProps = {
	iconRef: RefObject<HTMLDivElement>
	toggle: () => void
	color: RgbaColor
	setColor: SetColor
}

const Picker: FC<PickerProps> = ({iconRef, toggle, color, setColor}) => {
	const ref = useRef<HTMLDivElement>(null);

	// Auto-close if open and there's a click outside the color picker
	useOutsider([iconRef, ref], toggle);

	return (
		<div ref={ref}>
			<RgbaColorPicker
				className={styles.overlay}
				color={color}
				onChange={setColor}
			/>
		</div>
	);
};

export default Picker;
